<template>
  <div ref="main-dashborad" class="main-body" @keydown.esc="fullscreenChange">
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="card cardcontents maincardlayer">
          <div class="card-header non-label-icon mapheader maincardheader topmainlayer">
            <div class="title"><span class="title1">안전작업허가서 현황</span> <span class="title3">SWP</span></div>
            <q-btn 
              flat round 
              color="white" 
              class="mainmapstart fullscreen-btn"
              :icon="fullscreen ? 'fullscreen_exit' : 'fullscreen'" 
              @click="clickFullScreen">
              <q-tooltip v-if="fullscreen">
                <!-- 원래대로 -->
                {{setLabel('LBL0000327')}}
              </q-tooltip>
              <q-tooltip v-else>
                <!-- 전체화면 -->
                {{setLabel('LBL0000328')}}
              </q-tooltip>
            </q-btn>
            <div class="card-more main-header-input">
              <c-datepicker
                v-show="mapObj.activeTask===1"
                :range="true"
                :appendToBody="false"
                name="workPermitPeriod"
                v-model="mapObj.taskParam.workPermitPeriod"
                @datachange="getMapData"
              />
            </div>
            <!-- 시작 -->
            <!-- 정지 -->
            <q-btn 
              :outline="!mapObj.interval.isPause" 
              :color="mapObj.interval.isPause ? 'green-6' : 'white'" 
              :text-color="mapObj.interval.isPause ? 'white' : 'white'" 
              size="11px" class="mainmapstart startstopbtn"
              :label="mapObj.interval.isPause ? $comm.getLangLabel('LBL0000338') : $comm.getLangLabel('LBL0000339')"
              :icon="mapObj.interval.isPause ? 'restart_alt' : 'pause'"
              @click="pause">
              <!-- 업무영역 Rotate -->
              <q-tooltip>작업허가 위치 Rotate</q-tooltip>
            </q-btn>
            <div v-if="mapObj.interval.isPause" class="card-more main-header-input mainmapstartSecond">
              <c-text
                label=""
                prefix="반복 시간"
                suffix="(초)"
                type="number"
                name="settingSeconds"
                v-model="settingSeconds">
              </c-text>
            </div>
          </div>
          <div class="card-body maincardbody" ref="carousel" style="padding: 15px !important;" :loading="mapObj.loading">
            <template v-if="!mapObj.loading">
              <q-carousel
                v-if="mapObj.maps && mapObj.maps.length > 0"
                class="workPermit-carousel"
                swipeable
                animated
                arrows
                infinite
                control-type="regular"
                control-color="grey-6"
                v-model="mapObj.slide"
                @transition="transDisplay"
              >
                <q-carousel-slide 
                  v-for="(map, idx) in mapObj.maps"
                  :key="idx"
                  :name="idx" 
                  :img-src="map.mapSrc">
                  <template>
                    <div class="mapTitleDiv" v-text="map.mapName"></div>
                    <!-- 작업허가서 -->
                    <template v-if="mapObj.activeTask===1">
                      <VueDraggableResizable
                        v-for="(item, idx) in map.maps"
                        :key="idx"
                        ref="markImage"
                        class="mainMarkImage"
                        :class="item.idx === mapObj.maps[0].haveWorkPermitIdxs[mapObj.activeMarked - 1] ? 'selected' : ''"
                        :resizable="false"
                        :parent="true"
                        :draggable="false"
                        :x="item.locationXcoordinate * mapRate * mapObj.ratio"
                        :y="item.locationYcoordinate * mapRate * mapObj.ratio"
                        :w="40 " :h="40"
                        :grid="[20, 20]"
                      >
                        <c-map-marker :isSelected="item.idx === mapObj.maps[0].haveWorkPermitIdxs[mapObj.activeMarked - 1]" />
                      </VueDraggableResizable>
                    </template>
                    <!-- 작업허가서를 제외한 나머지 업무 -->
                    <VueDraggableResizable
                      v-for="(location, idx) in map.otherMaps"
                      :key="'other' + idx"
                      :ref="'locationMark' + location.mdmLocationId"
                      class="mainMarkImage"
                      :class="location.idx === mapObj.maps[0].haveWorkPermitIdxs[mapObj.activeMarked - 1] ? 'selected' : ''"
                      style="z-index:1"
                      :parent="true"
                      :draggable="false"
                      :resizable="false"
                      :x="location.x * mapRate * mapObj.ratio"
                      :y="location.y * mapRate * mapObj.ratio"
                      :w="40 " :h="40"
                      :grid="[20, 20]"
                    >
                      <c-map-marker :isSelected="location.idx === mapObj.maps[0].haveWorkPermitIdxs[mapObj.activeMarked - 1]" />
                    </VueDraggableResizable>
                    <VueDraggableResizable
                      v-for="(area, idx) in map.areas"
                      :key="'area' + idx"
                      class="my-class-display"
                      style="z-index:1"
                      :parent="true"
                      :draggable="false"
                      :resizable="false"
                      :x="area.x * mapRate * mapObj.ratio"
                      :y="area.y * mapRate * mapObj.ratio"
                      :w="area.w * mapRate * mapObj.ratio" 
                      :h="area.h * mapRate * mapObj.ratio"
                      :grid="[20, 20]"
                    >
                      <!-- :class="area.idx === mapObj.maps[0].haveWorkPermitIdxs[mapObj.activeMarked - 1] ? 'my-active-class' : ''" -->
                      <!-- @activated="onMarkedInfo(area)" -->
                      <!-- <div style="text-align:center;">{{area.areaName}}</div> -->
                      <q-menu 
                        :ref="'areaproxy' + area.idx" 
                        :persistent="true"
                        :content-class="'mainMapMenuLayer'"
                        anchor="top right"
                        self="top left"
                        @click.stop>
                        <!-- <q-toolbar class="bg-primary text-white shadow-2">
                          <q-toolbar-title>작업허가서 ({{selectedWorkPermit.areaName}})</q-toolbar-title>
                        </q-toolbar> -->
                        <q-card 
                          v-for="(workPermit, idx) in selectedWorkPermit.workPermits"
                          :key="idx"
                          flat bordered 
                          :class="['main-work-permit-card', setStepClass(workPermit.swpStepCd)]">
                          <q-item class="main-work-permit-card-section main-work-permit-card-item">
                            <q-item-section avatar>
                              <q-badge rounded :color="setStepColor(workPermit.swpStepCd)" :label="workPermit.swpStepName" />
                            </q-item-section>

                            <q-item-section>
                              <q-item-label>
                                <q-icon 
                                  v-for="(icon, iconIdx) in setTypeIcons(workPermit.sopWorkTypeCds)"
                                  :key="iconIdx"
                                  :name="icon" 
                                  class="text-red"
                                  size="25px" />
                              </q-item-label>
                            </q-item-section>
                          </q-item>
                          <q-card-section class="main-work-permit-card-section">
                            <q-icon 
                              name="chevron_right" 
                              class="text-indigo" 
                            />
                            <b>{{workPermit.workSummary}}</b> ({{workPermit.workTime}})
                          </q-card-section>
                          <q-card-section class="main-work-permit-card-section" v-if="workPermit.vendorName">
                            <q-icon 
                              name="chevron_right" 
                              class="text-indigo" 
                            /><b>작업업체 : {{workPermit.vendorName}}</b>
                          </q-card-section>
                          <q-card-section class="main-work-permit-card-section" v-if="workPermit.processName || workPermit.equipmentName">
                            <div v-if="workPermit.processName" class="main-work-permit-card-proc">
                              <q-chip
                                outline square
                                color="blue"
                                text-color="white">
                                {{workPermit.processName}}
                              </q-chip>
                            </div>
                            <div v-if="workPermit.equipmentName" class="main-work-permit-card-equip">
                              <q-chip
                                outline square
                                color="green"
                                text-color="white">
                                {{workPermit.equipmentName}}
                              </q-chip>
                            </div>
                          </q-card-section>
                        </q-card>
                      <!-- </q-popup-proxy> -->
                      </q-menu>
                    </VueDraggableResizable>
                  </template>
                </q-carousel-slide>
                <q-carousel-slide :name="mapObj.maps.length" class="etc-carousel">
                  <div class="row">
                    <div class="col-7">
                      <div class="cardcontents">
                        <div class="card-header card-etc-header">
                          일일 안전작업허가 목록
                        </div>
                        <div class="card-body nopadgrid">
                          <c-table
                            ref="gridWorkPermit"
                            tableId="gridWorkPermit"
                            :isTitle="false"
                            :isDashboard="true"
                            :columnSetting="false"
                            :usePaging="false"
                            :filtering="false"
                            :isFullScreen="false"
                            :hideBottom="true"
                            :gridHeight="gridHeight + 'px'"
                            :columns="gridWorkPermit.columns"
                            :data="gridWorkPermit.data"
                          >
                          </c-table>
                        </div>
                      </div>
                    </div>
                    <div class="col-5">
                      <div class="cardcontents">
                        <div class="card-header card-etc-header">
                          하역/선적/출하 현황
                        </div>
                        <div class="card-body nopadgrid">
                          <c-table
                            ref="gridUnload"
                            tableId="gridUnload"
                            :isTitle="false"
                            :isDashboard="true"
                            :columnSetting="false"
                            :usePaging="false"
                            :filtering="false"
                            :isFullScreen="false"
                            :hideBottom="true"
                            :gridHeight="(gridHeight / 2) + 'px'"
                            :columns="gridUnload.columns"
                            :data="gridUnload.data"
                          >
                            <template v-slot:customArea="{ props, col }">
                              <template v-if="col.name === 'mdmUnloadTypeName'">
                                <q-chip
                                  :color="props.row.mdmUnloadTypeName == '하역' ? 'orange' : 'blue'"
                                  outline square
                                  class="full-size-chip"
                                  text-color="white">
                                  {{props.row.mdmUnloadTypeName}}
                                </q-chip>
                              </template>
                            </template>
                          </c-table>
                        </div>
                        <div class="card-body nopadgrid">
                          <c-table
                            ref="gridShip"
                            tableId="gridShip"
                            :isTitle="false"
                            :isDashboard="true"
                            :columnSetting="false"
                            :usePaging="false"
                            :filtering="false"
                            :isFullScreen="false"
                            :hideBottom="true"
                            :gridHeight="(gridHeight / 2) + 'px'"
                            :columns="gridShip.columns"
                            :data="gridShip.data"
                          >
                          </c-table>
                        </div>
                      </div>
                    </div>
                  </div>
                </q-carousel-slide>
              </q-carousel>
              <!-- 등록된 지도가 없습니다. -->
              <el-empty v-else 
                :image-size="435"
                :description="$comm.getLangMessage('MSG0000122')">
              </el-empty>
              <!-- <el-drawer
                :class="setDrawerClass"
                :size="400"
                :withHeader="false"
                :wrapperClosable="false"
                :visible.sync="drawer.visible"
                :direction="selectedWorkPermit ? selectedWorkPermit.direction : 'rtl'"
                >
                <template v-if="isSelectedData">
                  <q-toolbar class="bg-primary text-white shadow-2">
                    <q-toolbar-title>작업허가서 ({{selectedWorkPermit.areaName}})</q-toolbar-title>
                  </q-toolbar>
                  <q-card 
                    v-for="(workPermit, idx) in selectedWorkPermit.workPermits"
                    :key="idx"
                    flat bordered 
                    class="main-work-permit-card">
                    <q-item class="main-work-permit-card-section main-work-permit-card-item">
                      <q-item-section avatar>
                        <q-badge rounded :color="setStepColor(workPermit.swpStepCd)" :label="workPermit.swpStepName" />
                      </q-item-section>

                      <q-item-section>
                        <q-item-label>
                          <q-icon 
                            v-for="(icon, iconIdx) in setTypeIcons(workPermit.sopWorkTypeCds)"
                            :key="iconIdx"
                            :name="icon" 
                            class="text-red"
                            size="25px" />
                        </q-item-label>
                      </q-item-section>
                    </q-item>
                    <q-card-section class="main-work-permit-card-section">
                    </q-card-section>
                    <q-card-section class="main-work-permit-card-section">
                      <q-icon 
                        name="chevron_right" 
                        class="text-indigo" 
                      />
                      <b>{{workPermit.workSummary}}</b> ({{workPermit.workTime}})
                    </q-card-section>
                    <q-card-section class="main-work-permit-card-section">
                      <q-icon 
                        name="chevron_right" 
                        class="text-indigo" 
                      /><b>설비 : {{workPermit.equipmentName}}</b>
                    </q-card-section>
                  </q-card>
                </template>
                <template v-else>
                  <q-toolbar class="bg-primary text-white shadow-2">
                    <q-toolbar-title>연결된 작업허가서가 없습니다...</q-toolbar-title>
                  </q-toolbar>
                </template>
              </el-drawer> -->
            </template>
            <template v-else>
            </template>
          </div>
        </div>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
    <q-inner-loading
      :showing="mapObj.loading"
      label="화면 조정중입니다."
      label-class="text-blue-grey"
      label-style="font-size: 8em"
      size="12em"
    >
      <q-spinner-grid size="12em" color="blue-grey" />
      <div class="text-blue-grey" style="font-size: 3em">
        화면 조정중
      </div>
    </q-inner-loading>
  </div>
</template>

<script>
import VueDraggableResizable from 'vue-draggable-resizable'
import mixinConvert from '@/js/mixin-template-convert'
import selectConfig from '@/js/selectConfig';
export default {
  name: 'indexDisplay',
  mixins: [mixinConvert],
  components: { 
    VueDraggableResizable,
  },
  props: {
  },
  data() {
    return {
      settingSeconds: 5,
      fullscreen: false,
      maintab1: 'dept',
      mapObj: {
        activeTask: 1,
        activeMarked: 1,
        envUrl: '',
        markInfoUrl: '',
        url: '',
        interval: {
          obj: null,
          seconds: 5,
          isPause: false,
          loopSeconds: 5,
        },
        taskParam: {
          workPermitPeriod: [],
        },
        location: {
          mdmLocationId: '',
          locationName: '',
          depts: [],
          chemprods: [],
          equips: [],
          hazardChems: [],
        },
        maps: [],
        orignMaps: [],
        slide: 0,
        height: 800,
        ratio: 1,
        orignRatio: 1,
        endIdx: 1,
        listShowSecond: 3,
        loading: false,
      },
      drawer: {
        visible: true,
      },
      gridHeight: 600,
      gridWorkPermit: {
        listUrl: '',
        columns: [
          {
            // 작업개요
            name: 'workSummary',
            field: 'workSummary',
            label: 'LBL0000211',
            align: 'left',
            sortable: false,
            style: 'width:170px',
          },
          {
            name: 'equipmentName',
            field: 'equipmentName',
            label: '설비유형 / 설비명',
            align: 'left',
            style: 'width:140px',
            sortable: false,
          },
          {
            // 작업업체
            name: 'vendorName',
            field: 'vendorName',
            label: '작업업체',
            align: 'center',
            sortable: false,
            style: 'width:85px',
          },
          {
            // 보충작업
            name: 'supplementWorkTypeNames',
            field: 'supplementWorkTypeNames',
            label: 'LBL0000205',
            align: 'left',
            sortable: false,
            style: 'width:130px',
          },
        ],
        data: [],
      },
      gridUnload: {
        listUrl: '',
        columns: [
          {
            name: 'mdmUnloadTypeName',
            field: 'mdmUnloadTypeName',
            label: '하역/선적',
            align: 'center',
            type: 'custom',
            sortable: false,
            style: 'width:90px',
          },
          {
            name: 'ownerName',
            field: 'ownerName',
            label: '화주사',
            align: 'left',
            sortable: false,
          },
          {
            name: 'shipName',
            field: 'shipName',
            label: '선명',
            align: 'left',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'workQty',
            field: 'workQty',
            label: '작업량',
            align: 'center',
            type: 'cost',
            style: 'width:80px',
            sortable: false,
          },
          {
            name: 'startDt',
            field: 'startDt',
            label: '시작일',
            align: 'center',
            style: 'width:100px',
            sortable: false,
          },
          {
            name: 'endDt',
            field: 'endDt',
            label: '종료일',
            align: 'center',
            style: 'width:100px',
            sortable: false,
          },
        ],
        data: [],
      },
      gridShip: {
        listUrl: '',
        columns: [
          {
            name: 'mdmShippingTypeName',
            field: 'mdmShippingTypeName',
            label: '출하구분',
            align: 'center',
            sortable: false,
            style: 'width:120px',
          },
          {
            name: 'workDt',
            field: 'workDt',
            label: '출하일자',
            align: 'center',
            style: 'width:100px',
            sortable: false,
          },
          {
            name: 'ownerName',
            field: 'ownerName',
            label: '화주사',
            align: 'left',
            sortable: false,
          },
          {
            name: 'workQty',
            field: 'workQty',
            label: '작업량',
            align: 'center',
            type: 'cost',
            style: 'width:100px',
            sortable: false,
          },
          {
            name: 'daynight',
            field: 'daynight',
            label: '주/야',
            align: 'center',
            style: 'width:70px',
            sortable: false,
          },
        ],
        data: [],
      },
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
    window.addEventListener('resize', this.setSize);
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setSize);
    clearInterval(this.mapObj.interval.obj);
  },
  computed: {
    mapRate() {
      return 1
    },
    colType() {
      return 'col-12'
    },
    colorItems() {
      return [
        // 계획수립
        { stepperMstCd: 'MCSC000005', stepperMstNm: this.$comm.getLangLabel('LBL0000381'), colorClass: 'blue' },
        // 점검중
        { stepperMstCd: 'MCSC000010', stepperMstNm: this.$comm.getLangLabel('LBL0000382'), colorClass: 'orange' },
        // 점검완료
        { stepperMstCd: 'MCSC000015', stepperMstNm: this.$comm.getLangLabel('LBL0000383'), colorClass: 'green' },
        // 지연
        { stepperMstCd: 'MCSC000020', stepperMstNm: this.$comm.getLangLabel('LBL0000384'), colorClass: 'red' },
      ]
    },
    isMapData() {
      return this.mapObj.maps
        && this.mapObj.maps.length > 0
        && this.$_.every(this.mapObj.maps, item => (item.maps && item.maps.length > 0) 
            || (item.otherMaps && item.otherMaps.length > 0)
      )
    },
    selectedWorkPermit() {
      let selected = {
        areaName: '',
        direction: 'rtl',
        workPermits: [],
      }
      if (this.isMapData && this.mapObj.activeMarked > 0) {
        let item = this.mapObj.maps[0] // 지도 1개
        let area = this.$_.find(item.areas, { idx: this.mapObj.maps[0].haveWorkPermitIdxs[this.mapObj.activeMarked - 1] });
        if (area) {
          selected.areaName = area.areaName
          selected.direction = area.direction
          let maps = this.$_.map(this.$_.filter(item.maps, { idx: this.mapObj.maps[0].haveWorkPermitIdxs[this.mapObj.activeMarked - 1] }), 'resultTypes');
          if (maps && maps.length > 0) {
            this.$_.forEach(maps, map => {
              selected.workPermits = this.$_.concat(selected.workPermits, map)
            })
          }
          let otherMaps = this.$_.map(this.$_.filter(item.otherMaps, { idx: this.mapObj.maps[0].haveWorkPermitIdxs[this.mapObj.activeMarked - 1] }), 'tasks');
          if (otherMaps && otherMaps.length > 0) {
            this.$_.forEach(otherMaps, map => {
              selected.workPermits = this.$_.concat(selected.workPermits, map)
            })
          }
        }
      }
      return selected;
    },
    // isSelectedData() {
    //   let selected = this.selectedWorkPermit;
    //   return selected
    //     && selected.workPermits 
    //     && selected.workPermits.length > 0
    // },
    // setDrawerClass() {
    //   let className = 'main-drawer ';
    //   if (!this.fullscreen) {
    //     if (this.selectedWorkPermit.direction === 'ltr') {
    //       className += 'no-full-ltr'
    //     } else {
    //       className += 'no-full-rtl'
    //     }
    //   } else {
    //     if (this.selectedWorkPermit.direction === 'ltr') {
    //       className += 'full-ltr right'
    //     } else {
    //       className += 'full-rtl left'
    //     }
    //   }
    //   return className;
    // },
    haveWorkPermit() {
      return this.mapObj.maps[0].haveWorkPermitIdxs 
        && this.mapObj.maps[0].haveWorkPermitIdxs.length > 0
    }
  },
  watch: {
  },
  methods: {
    init() {
      // url setting
      this.mapObj.url = selectConfig.main.map.url
      this.mapObj.markInfoUrl = selectConfig.main.mapProcess.url
      this.mapObj.envUrl = selectConfig.main.env.url
      this.gridWorkPermit.listUrl = selectConfig.sop.swp.workPermit.list.url;
      this.gridUnload.listUrl = selectConfig.mdm.unload.list.url;
      this.gridShip.listUrl = selectConfig.mdm.shipping.list.url;
      // list setting
      this.getMapPriodParam();
      this.getData();
      this.setSize(false);
    },
    getData() {
      this.getWorkPermits();
      this.getUnloadShips();
      this.getMapData();
    },
    getWorkPermits() {
      this.$http.url = this.gridWorkPermit.listUrl;
      this.$http.type = 'GET';
      this.$http.isLoading = false;
      this.$http.param = {
        plantCd: window.sessionStorage.getItem('defaultPlantCd'),
        permitDates: [this.$comm.getToday(), this.$comm.getToday()]
      }
      this.$http.request((_result) => {
        this.gridWorkPermit.data = _result.data
      },);
    },
    getUnloadShips() {
      this.getUnloads();
      this.getShips();
    },
    getUnloads() {
      this.$http.url = this.gridUnload.listUrl;
      this.$http.type = 'GET';
      this.$http.isLoading = false;
      this.$http.param = {
        plantCd: window.sessionStorage.getItem('defaultPlantCd'),
        searchDt: this.$comm.getToday()
      }
      this.$http.request((_result) => {
        this.gridUnload.data = _result.data
      },);
    },
    getShips() {
      this.$http.url = this.gridShip.listUrl;
      this.$http.type = 'GET';
      this.$http.isLoading = false;
      this.$http.param = {
        plantCd: window.sessionStorage.getItem('defaultPlantCd'),
        // dts: ['2021-02-05', '2024-02-05']
        dts: [this.$comm.getToday(), this.$comm.getToday()]
      }
      this.$http.request((_result) => {
        this.gridShip.data = _result.data
      },);
    },
    getMapPriodParam() {
      /**
       * 초기 지도 정보를 불러올 때에는 기간 정보가 넘어가지 않게 처리
       */
      this.$http.url = this.mapObj.envUrl;
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.$set(this.mapObj.taskParam, 'workPermitPeriod', [_result.data[0].start, _result.data[0].end])
      },);
    },
    getMapData(loading) {
      // interval 없앤 후 조회
      clearInterval(this.mapObj.interval.obj);
      let defaultPlantCd = window.sessionStorage.getItem('defaultPlantCd');
      this.$http.url = this.mapObj.url;
      this.$http.type = 'GET';
      this.$http.isLoading = false;
      this.$http.param = {
        plantCd: defaultPlantCd,
        workPermitPeriod: this.mapObj.taskParam.workPermitPeriod,
      }
      this.$http.request((_result) => {
        if (_result.data.length > 0) {
          /**
           * 지도는 1개
           */
          this.$_.forEach(_result.data, item => {
            let width = 800 * _result.data[0].ratio
            let widthHalf = width / 2

            /**
             * 총 20개의 구역을 마련 (4x5)
             */
            let heightDivide = 4
            let widthDivide = 5
            let area = {
              h: 800 / heightDivide,
              w: width / widthDivide,
            }
            item.areas = [];
            for (let height = 0; height < heightDivide; height++) {
              for (let width = 0; width < widthDivide; width++) {
                item.areas.push({
                  x: width * area.w,
                  y: height * area.h,
                  w: area.w,
                  h: area.h,
                  idx: (width + 1) + (height * widthDivide),
                  areaName: 'AREA ' + ((width + 1) + (height * widthDivide)),
                  direction: widthHalf > width * area.w ? 'rtl' : 'ltr'
                })
              }
            }

            // 작업허가서가 존재하는 idx 수집
            item.haveWorkPermitIdxs = [];

            if (item.otherMaps && item.otherMaps.length > 0) {
              this.$_.forEach(item.otherMaps, map => {
                let area = this.$_.find(item.areas, area => {
                  return area.x <= map.x + 20 && area.x + area.w > map.x + 20
                    && area.y <= map.y + 20 && area.y + area.h > map.y + 20
                })
                this.$set(map, 'idx', area ? area.idx : 0)
                this.$set(map, 'direction', widthHalf > map.x ? 'rtl' : 'ltr')
                if (this.$_.indexOf(item.haveWorkPermitIdxs, map.idx) === -1 && map.tasks && map.tasks.length > 0) {
                  item.haveWorkPermitIdxs.push(map.idx)
                }
              })
            }
            if (item.maps && item.maps.length > 0) {
              this.$_.forEach(item.maps, map => {
                let area = this.$_.find(item.areas, area => {
                  return area.x <= map.locationXcoordinate + 20 && area.x + area.w > map.locationXcoordinate + 20
                    && area.y <= map.locationYcoordinate + 20 && area.y + area.h > map.locationYcoordinate + 20
                })
                this.$set(map, 'idx', area ? area.idx : 0)
                this.$set(map, 'direction', widthHalf > map.locationXcoordinate ? 'rtl' : 'ltr')
                if (this.$_.indexOf(item.haveWorkPermitIdxs, map.idx) === -1 && map.resultTypes && map.resultTypes.length > 0) {
                  item.haveWorkPermitIdxs.push(map.idx)
                }
              })
            }
            item.haveWorkPermitIdxs = this.$_.sortBy(item.haveWorkPermitIdxs)
            this.mapObj.endIdx = item.haveWorkPermitIdxs.length; // heightDivide * widthDivide;
          })

          this.mapObj.maps = this.$_.cloneDeep(_result.data)
          this.mapObj.orignRatio = this.mapObj.maps[0].ratio;
          
          this.$refs['carousel'].style.setProperty("--map-ratio", this.mapObj.maps[0].ratio);
        }

        if (this.mapObj.endIdx  === 0) {
          this.mapObj.endIdx = 1;
        }
        // 로딩바 제거
        if (loading) {
          this.mapObj.loading = false;
          this.pause();
        } else if (this.mapObj.endIdx > 1) {
          if (this.haveWorkPermit) {
            setTimeout(() => {
              this.$refs['areaproxy' + this.mapObj.maps[0].haveWorkPermitIdxs[0]][0].show()
            }, 100);
          }
          this.intervalActionMap();
        } else {
          this.intervalActionMap();
        }
      },);
    },
    intervalActionMap() {
      /**
       * 순서 : mark > location area > map
       */
      this.mapObj.interval.obj = setInterval(() => {
        this.mapObj.interval.seconds--
        
        let isMap = this.mapObj.slide !== this.mapObj.maps.length
        if (this.mapObj.interval.seconds === 0) {
          if (isMap && this.haveWorkPermit) {
            this.$refs['areaproxy' + this.mapObj.maps[0].haveWorkPermitIdxs[this.mapObj.activeMarked - 1]][0].hide()
          }
          if (this.mapObj.activeMarked === this.mapObj.endIdx) {
            // 지도에 표시된 mark를 전부 rotate한 경우
            if (isMap) {
              this.mapObj.slide++ // = this.mapObj.maps.length;
              this.mapObj.listShowSecond = 3;
            } else if (this.mapObj.listShowSecond > 0) {
              this.mapObj.listShowSecond--;
            } else if (this.mapObj.listShowSecond === 0) {
              this.mapObj.activeMarked = 1
              this.mapObj.slide = 0;
              clearInterval(this.mapObj.interval.obj);
              this.getData(); // 1 cycle 1 select
              if (this.haveWorkPermit) {
                setTimeout(() => {
                  this.$refs['areaproxy' + this.mapObj.maps[0].haveWorkPermitIdxs[0]][0].show()
                }, 300);
              }
            }
          } else {
            this.mapObj.activeMarked++;
          }
          if (isMap && this.haveWorkPermit) {
            this.$refs['areaproxy' + this.mapObj.maps[0].haveWorkPermitIdxs[this.mapObj.activeMarked - 1]][0].show()
          }
          this.mapObj.interval.seconds = this.$_.clone(this.mapObj.interval.loopSeconds);
        }
      }, 1000);
    },
    setSize(flag) {
      /**
       * 지도의 기본 높이는 800
       * 윈도우 사이즈에 맞추어 높이가 변경될 시에 그에 맞는 ratio가 따로 필요
       */
      if (flag !== false) {
        this.mapObj.loading = true;
        this.pause();
      }
      this.$set(this.mapObj, 'maps', [])
      let margin = this.fullscreen === false ? 200 : 105;
      let gridMargin = this.fullscreen === false ? 310 : 215;
      this.mapObj.height = window.innerHeight - margin
      this.gridHeight = window.innerHeight - gridMargin
      let resizeRatio = Math.round(this.mapObj.height / 800 * 100) / 100;
      let _height = this.mapObj.height * this.mapRate
      this.$refs['carousel'].style.setProperty("--map-height", String(_height) + 'px');
      this.mapObj.ratio = resizeRatio;
      setTimeout(() => {
        if (flag !== false) {
          this.getMapData(true);
        }
      }, 300);
    },
    pause() {
      this.mapObj.interval.isPause = !this.mapObj.interval.isPause
      if (this.mapObj.interval.isPause) {
        clearInterval(this.mapObj.interval.obj);
      } else {
        this.mapObj.interval.loopSeconds = this.settingSeconds;
        this.intervalActionMap()
      }
    },
    imgHeight(map) {
      return String(map.ratio * this.mapObj.height) + 'px'
    },
    setStepColor(swpStepCd) {
      let color = '';
      switch(swpStepCd) {
        case 'SS00000005':
          color = 'light-blue';
          break;
        case 'SS00000010':
          color = 'amber';
          break;
        case 'SS00000020':
          color = 'light-green';
          break;
      }
      return color;
    },
    setStepClass(swpStepCd) {
      let _class = '';
      switch(swpStepCd) {
        case 'SS00000005':
        _class = 'main-work-permit-card-light-blue';
          break;
        case 'SS00000010':
        _class = 'main-work-permit-card-amber';
          break;
        case 'SS00000020':
        _class = 'main-work-permit-card-light-green';
          break;
      }
      return _class;
    },
    setTypeIcons(sopWorkTypeCds) {
      let icons = [];
      let typeArray = sopWorkTypeCds && sopWorkTypeCds.length > 0 ? sopWorkTypeCds.split(',') : [];
      if (typeArray && typeArray.length > 0) {
        this.$_.forEach(typeArray, type => {
          switch(type) {
            case 'SPT0000001': // 일반
              icons.push('engineering');
              break;
            case 'SPT0000005': // 화기
              icons.push('local_fire_department');
              break;
            case 'SSWT000001': // 밀폐공간
              icons.push('dangerous');
              break;
            case 'SSWT000005': // 정전
              icons.push('flash_off');
              break;
            case 'SSWT000010': // 방사선
              icons.push('warning');
              break;
            case 'SSWT000015': // 굴착
              icons.push('hardware');
              break;
            case 'SSWT000020': // 고소
              icons.push('stairs');
              break;
            case 'SSWT000025': // 중장비
              icons.push('agriculture');
              break;
          }
        })
      }
      return icons;
    },
    openWorkPermit(item) {
      if (!item) return;
      this.popupOptions.isFull = true;
      this.popupOptions.title = 'LBL0000938' //'작업허가서 상세';
      this.popupOptions.param = {
        sopWorkPermitId: item.sopWorkPermitId,
        permitTypeCd: item.permitTypeCd,
      };
      this.popupOptions.target = () => import(`${'@/pages/sop/swp/safeWorkPermitDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeWorkPermitPopup;
    },
    closeWorkPermitPopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
    /* eslint-disable no-unused-vars */
    getWidth(item) {
      let width = 0;
      this.$_.forEach(item.resultTypes, resultType => {
        width += (resultType.sopWorkTypeName.length * 10) + 60
      })
      return width + 'px'
    },
    getLeft(item) {
      /**
       * 지도의 크기는 800
       */
      let left = 0;
      let nonDetailLocation = item.locationXcoordinate + (item.resultTypes.length * 40)
      let detailLocation = item.locationXcoordinate + 250
      let calLocation = nonDetailLocation > detailLocation ? nonDetailLocation : detailLocation
      if (calLocation > this.mapObj.height) {
        left = this.mapObj.height * this.mapObj.ratio * this.mapRate - calLocation
      }
      return left + 'px'
    },
    getTop(item) {
      /**
       * 지도의 높이는 800
       */
      let top = 30;
      let calLocation = item.locationYcoordinate + (item.resultTypes.length * 76)
      if (calLocation > this.mapObj.height) {
        top = this.mapObj.height * this.mapObj.ratio * this.mapRate - calLocation
      }
      return !item.isHover ? '30px' : top + 'px'
    },
    clickFullScreen() {
      let element = this.$refs['main-dashborad']
      if (this.fullscreen === false) {
        this.fullscreen = true;
        let requestMethod = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen;

        if (requestMethod) { // Native full screen.
          requestMethod.call(element);
        }
      } else {
        this.fullscreen = false;
        let requestMethod = document.exitFullscreen || document.cancelFullScreen || document.webkitCancelFullScreen || document.mozCancelFullScreen || document.msExitFullscreen;
        if (requestMethod) { // Native full screen.
          requestMethod.call(document);
        }		
      }
    },
    onMarkedInfo(area) {
      this.$refs['area2'][0].$el.click()
    },
    transDisplay(newVal, oldVal) {
      if (newVal === 1) {
        // 목록을 보여주는 경우
        this.$set(this.mapObj, 'activeMarked', this.mapObj.endIdx)
      } else {
        // 지도를 보여주는 경우
        this.$set(this.mapObj, 'activeMarked', 1)
        if (this.haveWorkPermit) {
          setTimeout(() => {
            this.$refs['areaproxy' + this.mapObj.maps[0].haveWorkPermitIdxs[0]][0].show()
          }, 300);
        }
      }
    },
  }
};
</script>
<style lang="sass">
  .main-body:fullscreen 
    overflow: scroll !important
  .main-body:-ms-fullscreen 
    overflow: scroll !important
  .main-body:-webkit-full-screen 
    overflow: scroll !important
  .main-body:-moz-full-screen 
    overflow: scroll !important
  
  .mainlayoutback
    background-color: #161d31 !important
  .mainlayoutback .row > .col-sm-12:not(:last-child)
    padding-right: 0px !important
  .topmainlayer
    border-radius: 10px 10px 10px 10px !important
    height: 76px
    background-color: #283046 !important
    display: block
    div.title
      // padding: 10px 0px 0px 30px
      font-weight: 600
      color: #7367f0
      font-size: 20px
      display: inline-block
    .title1
      color: #fff
      font-size: 22px
    .title2
      color: #fff
      font-size: 32px
    .title3
      color: #7367f0
      font-size: 25px
    .mainbtns
      float: right !important
      display: inline-block
    .mainbtnscreen
      margin-top: 15px
      padding-right: 10px
      float: right !important
      display: inline-block
  .maincardlayer
    background-color: #161d31 !important
  .maincardheader
    border-radius: 10px 10px 0 0 !important
    background-color: #343d55 !important
    .customdatelabel
      margin-top: 0px !important
    .cdatetimepic .inputClass
      width: 220px !important
      max-width: 220px !important
      background-color: #343d55 !important
      color: #fff !important
      border-width: 0px !important
    .cdatetimepic .mx-input-wrapper
      padding: 0px 3px !important
      margin-bottom: 0px !important
      .mx-icon-clear
        color: #fff !important
      .mx-icon-calendar
        color: #fff !important
  .mainmapstart
    float: right
    margin-right: 20px
  .startstopbtn
    margin-top: 4px
  .mainmapstartSecond
    float: right
    margin-right: 10px
    input
      color: #fff !important
    .q-field__suffix
      color: #fff !important
  .fullscreen-btn
    .q-btn__wrapper
      min-width: 10px !important
      min-height: 10px !important
      // max-width: 10px !important
      // max-height: 10px !important
  .main-header-input
    width: 220px !important
  .maincardbody
    background-color: #283046
    border-radius: 0 0 10px 10px !important
    
  .mainchild
    margin-top: -75px !important
    padding: 20px 20px 5px 20px
  .maincard
    margin-right: 6px
    margin-bottom: 6px
  .maincard:hover
    margin-top: -10px
  .cardcontents
    margin-top: 6px
    margin-bottom: 6px
    margin-right: 6px
    .card-body
      padding: 10px !important
    .card-header:not(.non-label-icon):before
      font-family: "Material Icons"
      content: "\e876"
    .card-header
      height: 50px
      width: 100%
      color: #1ab394
      background: #f8f8f8
      display: inline-block
      padding-top: 8px
      .card-more
        float: right !important
        cursor: pointer
        color: #d2d2d2
      .card-more:hover
        color: #1ab394
    .card-etc-header
      height: 30px
      padding-top: 0px
  .maincard .card-body
    background: #fff
    border-radius: 5px
    padding: 15px !important
    .fw-bold
      font-weight: 600
    .material-icons
      font-size: 3em
      color: #ddd
      cursor: pointer
  .maincard .card-body.border-color-blue
    border-left: 4px solid #0061f2
  .maincard .card-body.border-color-red
    border-left: 4px solid #d92550
  .maincard .card-body.border-color-yullow
    border-left: 4px solid #f7b924
  .maincard .card-body.border-color-green
    border-left: 4px solid #3ac47d

.mainMarkImage
  padding: 0px !important
  // text-align: center
  font-size: 20px
  height: 30px !important
  position: absolute
  padding: 16px
  // color: #C10015
  z-index: 3 !important
  // background: rgba(0,0,0,0.47)
  .markImage-abbreviation-parent
    // width:240px
    text-align: start
    position: absolute
    .markImage-abbreviation
      cursor: pointer
      display: inline-block
      // min-width:60px
      // max-width:250px
      width: auto
      border-left: 1px solid #757575
      border-right: 1px solid #757575
      border-top: 1px solid #757575
      border-bottom: 1px solid #757575
      border-radius: 5px
      .markImage-tran
        border-radius: 5px
      .markImage-abbreviation-banner
        border-right: 1px solid #757575
        display: inline-block
        text-align: center
        min-width:60px
        padding: 1px !important
        border-radius: 5px 0px 0px 5px
        i
          font-size: 20px
        div
          font-size: 12px !important
      .markImage-abbreviation-banner.last-banner
        border-right: 0
        border-radius: 0px 5px 5px 0px
      .markImage-abbreviation-plus
        display: inline-block
        text-align: center
        min-width:40px
      .markImage-abbreviation-banner-detail
        border-radius: 5px
        .q-banner__avatar i
          font-size: 20px !important
        .q-banner__content
          font-size: 12px !important
  .markedBadage
    font-family: "Nanum Gothic", "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"
.markImage-abbreviation > div
  -webkit-animation: fadeInFromNone 0.1s ease-out
  -moz-animation: fadeInFromNone 0.1s ease-out
  -o-animation: fadeInFromNone 0.1s ease-out
  animation: fadeInFromNone 0.1s ease-out

.mainMarkImage.selected
  z-index: 3000 !important


// .mark-list-enter-active, .mark-list-leave-active
//   transition: all 0.1s
.mark-list-enter, .mark-list-leave-to
  opacity: 0
  transform: translateY(5px)

.caption-work
  font-size: 0.9em
  // font-style: italic
  white-space: normal
  color: #555
  margin-top: 4px

.caption-work2
  font-size: 0.9em
  // font-style: italic
  white-space: normal
  color: #fff
  padding: 10px

.workPermit-carousel
  border-radius: 10px
  height: var(--map-height) !important
  .q-carousel__slide
    width: calc(var(--map-ratio) * var(--map-height)) !important
    margin: 0 auto
  .etc-carousel
    margin: 0 !important
    width: 100% !important
  .q-carousel--padding, .q-carousel__slide
    padding: 0 !important
  .q-carousel__arrow
    transition: all 0.5s
    opacity: 0.2
  .q-carousel__arrow:hover
    transition: all 0.5s
    opacity: 0.8
  .q-carousel__slides-container
    .q-panel.scroll
      // overflow: hidden !important

.main-header-input
  // margin-top: -5px
  padding-right: 5px
  .customDate
    padding-bottom: 0 !important
    .q-field__inner
      padding: 0 !important
.maintabbody
  background-color: #283046
.padding-left10
  padding-left: 10px !important

@-webkit-keyframes fadeInFromNone
  0%
    opacity: 0
  50%
    opacity: 0
  70%
    opacity: 0.5
  100%
    opacity: 1

@-moz-keyframes fadeInFromNone
  0%
    opacity: 0
  50%
    opacity: 0
  70%
    opacity: 0.5
  100%
    opacity: 1

@-o-keyframes fadeInFromNone
  0%
    opacity: 0
  50%
    opacity: 0
  70%
    opacity: 0.5
  100%
    opacity: 1

@keyframes fadeInFromNone
  0%
    opacity: 0
  50%
    opacity: 0
  70%
    opacity: 0.5
  100%
    opacity: 1


.main-map-card 
  border-radius: 10px !important
  border-width: 0px !important
  background-color: #161d31 !important
  .q-tab--inactive
    border: 1px solid #fff
    margin: 0px 2px !important
    border-radius: 5px !important
  .q-tab--active
    border: 1px solid #fff
    margin: 0px 2px !important
    border-radius: 5px !important
    background-color: #fff !important
    color:  #161d31 !important
  .q-tab__indicator
    display: none !important
  .customCardbody
    margin: 0px !important
    .main-card-head-text
      font-weight: 600
      font-size: 0.9rem
      line-height: 26px
  .cardhead
    height: 41px !important
    background-color: #343d55 !important
    color: #fff !important
    padding-top: 5px !important
    font-size: 1.1em !important
  .customCardbody
    background-color: #283046 !important
    border-radius: 0 0 10px 10px !important
    padding-top: 10px !important
  .q-separator--horizontal
    display: none !important
  .mainDashboardTab
    .q-tab-panel
      display: table
      width: 100%
    .q-tab__label
      font-size: 1.0em !important
      font-weight: 600
  .mainDashboardTabS
    .q-tab__label
      font-size: 1.1em !important
  .maintabTable
    width: 100%
    display: inline-flex
    color: #fff !important
  .maintabTableTop
    border-top: 1px solid rgb(255,255,255, 0.3)
    border-left: 1px solid rgb(255,255,255, 0.3)
    border-right: 1px solid rgb(255,255,255, 0.3)
  .maintabTd
    font-size: 1.1em !important
    padding: 8px 5px
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
    width: 100%
  .maintabTr
    font-size: 1.1em !important
    padding: 8px 5px
    width: 100%
    background-color: #161d31 !important
  .maintabTd7
    width: 70%
  .maintabTd6
    width: 60%
  .maintabTd5
    width: 50%
  .maintabTd4
    width: 40%
  .maintabTd3
    width: 30%
    text-align: right
  .maintabTd2
    width: 20%
  .maintabTd1
    width: 10%
  .maintabTdgreen
    color: #28c76f !important
    font-size: 1.05em !important
    text-align: center
  .maintablebody
    height: 250px
    background-color: #343d55 !important
    border-radius: 0 0 10px 10px !important
    overflow-y: auto
    border-bottom: 1px solid rgb(255,255,255, 0.3)
    border-left: 1px solid rgb(255,255,255, 0.3)
    border-right: 1px solid rgb(255,255,255, 0.3)
  .maintablebody2
    height: 300px !important

.main-drawer.no-full-rtl
  top: 120px !important
  right: 30px !important
  bottom: 60px !important
.main-drawer.no-full-ltr
  top: 120px !important
  left: 270px !important
  bottom: 60px !important
.main-drawer.full-rtl
  top: 120px !important
  right: 30px !important
  bottom: 60px !important
.main-drawer.full-ltr
  top: 120px !important
  left: 30px !important
  bottom: 60px !important
.main-drawer
  .el-drawer
    border-radius: 10px 10px
.main-work-permit-card
  padding-top: 5px
  padding-bottom: 5px
  margin: 6px
  .main-work-permit-card-section
    padding: 0 10px 0 10px
  .main-work-permit-card-item
    min-height: auto

.v-modal
  z-index: 0 !important
.mainMapMenuLayer
  border-radius: 10px !important
  max-width: 600px !important
.main-work-permit-card-proc
  margin-right: 6px !important
.main-work-permit-card-equip, .main-work-permit-card-proc
  display: inline-block
  padding-top: 4px !important
  padding-bottom: 4px !important
</style>
<style scoped>
.widget-numbers {
  font-size: 20px;
}
.impr-item {
  height: 100% !important;
}
.my-class-display {
  /* background-color: #9E9E9E; */
  border: 0px solid rgba(255, 255, 255, 0.7) !important; 
  /* border: 1px solid black;
  background-color: rgba(40, 48, 70, 0.2);
  border-radius: 10px;
  -webkit-transition: background-color 200ms linear;
  -ms-transition: background-color 200ms linear;
  transition: background-color 200ms linear; */
  position: absolute;
  /* text-align: center; */
  color: black;
  /* cursor: pointer; */
  /* z-index: 1 !important; */
}
.my-class-display div {
  width: 100%;
  border-radius: 10px 10px 0 0;
  color: #fff;
  background-color: rgba(40, 48, 70, 0.6);
}
.my-active-class {
  /* opacity: 0.5; */
  background-color: rgba(115,103,240,0.5);
  /* color:azure; */
  z-index:3000;
}
.chip-task {
  margin-left: 8px !important;
}
.mainlayoutback .main-body {
  overflow-x: hidden !important;
  overflow-y: auto !important;
}
.mainlayoutback .task-detail {
  z-index: 5;
  width:250px;
  position: relative;
}
.mainlayoutback .task-detail .q-banner {
  background-color: #283046;
  border-radius: 5px;
  border-bottom: 1px solid #fff;
  border-left: 1px solid #fff;
  border-right: 1px solid #fff;
  padding: 0px !important;
}
.mainlayoutback .task-detail .q-banner .col-auto {
  padding: 0px !important;
}
.mainmapbannerTitle {
  width: 100%;
  color: #fff;
  background-color: #343d55;
  padding: 10px !important;
  border-radius: 3px;
}
.open-task {
  left: 100%; 
  width: 80%;
  transform: translate(-100%, 0);
  position: absolute;
  z-index: 1000;
  padding: 10px !important;
  border-radius: 15px !important;
  background: #fff;
  z-index: 2001;
}
.maintablebody::-webkit-scrollbar {
  width: 10px;
}
.maintablebody::-webkit-scrollbar-track {
  background: #343d55 !important;
  border-radius: 0 0 10px 0;
}

.maintablebody::-webkit-scrollbar-thumb {
  background-color: #161d31 !important;
  background-image: linear-gradient(315deg, #161d31 0%, #161d31 74%);
}
.link-line {
  text-decoration: underline;
  cursor: pointer;
}
.mapTitleDiv {
  position: absolute;
  right: 5px;
  top: 5px;
  border-radius: 10px;
  background-color: #283046 !important;
  color: #fff;
  padding: 5px 10px;
  font-weight: 700;
  z-index: 2000;
  font-size: 12px;
}
.main-work-permit-card-light-blue {
  border-top: 2px solid #03a9f4;
}
.main-work-permit-card-amber {
  border-top: 2px solid #ffc107;
}
.main-work-permit-card-light-green {
  border-top: 2px solid #8bc34a;
}
</style>